import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { States } from './shared/state.model';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {
  @Input()
  form: FormGroup;
  states = States;

  constructor() {}

  ngOnInit(): void {}

  get zip() {
    return this.form.get('location.zip') as FormControl;
  }

  get state() {
    return this.form.get('location.state') as FormControl;
  }
}
